export default [
  {
    path:'/admin/statistics/order_total',
    name:'OrderTotal',
    component:()=>import("../views/statistics/order_total"),
    meta:{
      title:'统计-订单统计'
    }
  },
  {
    path:'/admin/statistics/overview',
    name:'StatisticsOverview',
    component:()=>import("../views/statistics/overview"),
    meta:{
      title:'统计-资产总览'
    }
  },
  {
    path: '/admin/statistics/bond_record',
    name: 'StatisticsBondRecord',
    component: () => import("../views/statistics/bond_record"),
    meta: {
      title: '统计-保证金',
      keepAlive: false
    }
  },
  {
    path: '/admin/statistics/billing_records',
    name: 'StatisticsBillingRecords',
    component: () => import("../views/statistics/billing_records"),
    meta: {
      title: '统计-账单记录'
    }
  },
  {
    path: '/admin/statistics/trade_record',
    name: 'StatisticsTradeRecord',
    component: () => import("../views/statistics/trade_record"),
    meta: {
      title: '统计-交易记录'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/statistics.js